import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, TreeSelect, message, Row, Col, Statistic } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import { CheckImgs } from "../../component/common/Imgs"
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    clueDate: any
    customer_name: string | undefined
    phone: string | undefined
    contact_way: string | undefined
    preg_status: number | undefined
    date: any
    is_effective_customer: number | undefined
    customer_status: string | undefined
    location_city_name: string | undefined
    intention_store_id: string[] | undefined,
    channel_id: string[] | undefined,
    channel_manager_id: string | undefined,
    channel_anchor_id: string | undefined,
    create_user_name: string | undefined
    create_user_position_number: number | undefined
    recordDate: any
    belong_cs_id: string | undefined,
    belong_hospital_id: undefined // 所属医务
    first_belong_store_id: string[] | undefined,
    first_belong_sales_id: string | undefined,
    belong_store_id: string[] | undefined,
    init_sales_id: string | undefined
    init_sales_name: string | undefined,
    follow_sales_id: string | undefined
    follow_sales_name: string | undefined,
    has_gone: number | undefined
    no_effective_reason_id: string | undefined,
    before_gone_init_store_id: string[] | undefined,
    before_gone_init_sales_id: string | undefined
    before_gone_follow_sales_id: string | undefined
    follow_level_id: string | undefined,
    min_follow_times: string | undefined
    max_follow_times: string | undefined
    lastFollowDate: any
    nextFollowEndDate: any
    min_total_visit_times: number | undefined
    max_total_visit_times: number | undefined
    visitStoreDate: any
    visit_store_id: string | undefined,
    dealDate: any
    deal_store_id: string | undefined
    deal_sales_id: string | undefined
    deal_sales_name: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

type fromItem = {
    id: string,
    channel_name: string
}

type belongKF = {
    "id": string,
    "user_name": string
}

type followLevel = {
    "id": string,
    "follow_level": string
}

type followSales = {
    "id": string,
    "user_name": string
}

type loseType = {
    "id": string,
    "reason_desc": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        clueDate: null,
        customer_name: undefined,
        phone: undefined,
        contact_way: undefined,
        preg_status: undefined,
        date: null,
        is_effective_customer: undefined,
        customer_status: undefined,
        location_city_name: undefined,
        intention_store_id: undefined,
        channel_id: undefined,
        channel_manager_id: undefined,
        channel_anchor_id: undefined,
        create_user_name: undefined,
        create_user_position_number: undefined,
        recordDate: null,
        belong_cs_id: undefined,
        belong_hospital_id: undefined,
        first_belong_store_id: undefined,
        first_belong_sales_id: undefined,
        belong_store_id: undefined,
        init_sales_id: undefined,
        init_sales_name: undefined,
        follow_sales_id: undefined,
        follow_sales_name: undefined,
        has_gone: undefined,
        no_effective_reason_id: undefined,
        before_gone_init_store_id: undefined,
        before_gone_init_sales_id: undefined,
        before_gone_follow_sales_id: undefined,
        follow_level_id: undefined,
        min_follow_times: undefined,
        max_follow_times: undefined,
        lastFollowDate: null,
        nextFollowEndDate: null,
        min_total_visit_times: undefined,
        max_total_visit_times: undefined,
        visitStoreDate: null,
        visit_store_id: undefined,
        dealDate: null,
        deal_store_id: undefined,
        deal_sales_id: undefined,
        deal_sales_name: undefined,
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: true
    })

    const [initDate, setInitDate] = useState<boolean>(true)

    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [belongKFData, setBelongKFData] = useState<belongKF[]>([])
    const [belongHospital, setBelongHospital] = useState<any[]>([])
    const [inChargeData, setInChargeData] = useState<belongKF[]>([])
    const [channelAnchorData, setChannelAnchorData] = useState<belongKF[]>([])
    const [fromItemData, setFromItemData] = useState<fromItem[]>([])
    const [followLevelData, setFollowLevelData] = useState<followLevel[]>([])
    const [loseTypeData, setLoseTypeData] = useState<loseType[]>([])
    const [followSalesData, setFollowSalesData] = useState<followSales[]>([])

    const [lossVisible, setLossVisible] = useState<boolean>(false)
    const [lossData, setLossData] = useState<any[]>([])

    const [followRecordVisible, setFollowRecordVisible] = useState<boolean>(false)
    const [followRecordData, setFollowRecordData] = useState<any[]>([])

    const [inStoreRecordVisible, setInStoreRecordVisible] = useState<boolean>(false)
    const [inStoreRecordData, setInStoreRecordData] = useState<any[]>([])

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [inMoneyRecordVisible, setInMoneyRecordVisible] = useState<boolean>(false)
    const [inMoneyRecordData, setInMoneyRecordData] = useState<any>({ "total_agreement_amount": 0, "total_review_amount": 0, "total_pay_amount": 0, pay_records_list: [] })

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (initDate) {
            var startDate = moment().startOf('month');
            var endDate = moment().endOf('month');
            // 初始化线索日期
            fetchOtherParams.clueDate = [startDate, endDate];

            setInitDate(false)
        }

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    useEffect(() => {
        // 查询来源渠道列表
        baseAxiosNoInfo('/finance_center/global/channel_source_list').then((res: any) => {
            res && setFromItemData(res)
        })

        baseAxiosNoInfo('/markting_center/global/follow_level_list').then((res: any) => {
            res && setFollowLevelData(res)
        })

        baseAxiosNoInfo('/markting_center/global/no_effective_reason').then((res: any) => {
            res && setLoseTypeData(res)
        })

        baseAxiosNoInfo('/global/employee_list', { params: { position_number: 1 } }).then((res: any) => {
            res && setBelongKFData(res)
        })

        baseAxiosNoInfo('/global/employee_list', { params: { position_number: 2 } }).then((res: any) => {
            res && setBelongHospital(res)
        })

        baseAxiosNoInfo('/global/employee_list', { params: { position_number: '11,13,14,15' } }).then((res: any) => {
            res && setInChargeData(res)
        })

        baseAxiosNoInfo('/global/employee_list', { params: { position_number: 3 } }).then((res: any) => {
            res && setFollowSalesData(res)
        })

        baseAxiosNoInfo('/markting_center/global/channel_anchor_list', {}).then((res: any) => {
            res && setChannelAnchorData(res)
        })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'clueDate', ['start_clue_date', 'end_clue_date'])
        handleDate(params, 'date', ['start_expect_born_day', 'end_expect_born_day'])
        handleDate(params, 'recordDate', ['start_create_time', 'end_create_time'])

        handleDate(params, 'lastFollowDate', ['start_last_follow_time', 'end_last_follow_time'])
        handleDate(params, 'nextFollowEndDate', ['start_next_follow_end_time', 'end_next_follow_end_time'])
        handleDate(params, 'visitStoreDate', ['start_visit_store_date', 'end_visit_store_date'])
        handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])

        if (params.channel_id) {
            params.channel_id = params.channel_id.join(',')
        }

        if (params.intention_store_id) {
            params.intention_store_id = params.intention_store_id.join(',')
        }

        if (params.first_belong_store_id) {
            params.first_belong_store_id = params.first_belong_store_id.join(',')
        }

        if (params.belong_store_id) {
            params.belong_store_id = params.belong_store_id.join(',')
        }

        if (params.before_gone_init_store_id) {
            params.before_gone_init_store_id = params.before_gone_init_store_id.join(',')
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        axiosTable.get('/markting_center/customer/intention/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setInitDate(false)
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        message.success('此次导出需要较长时间，请稍等..')

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'clueDate', ['start_clue_date', 'end_clue_date'])
        handleDate(params, 'date', ['start_expect_born_day', 'end_expect_born_day'])
        handleDate(params, 'recordDate', ['start_create_time', 'end_create_time'])

        handleDate(params, 'lastFollowDate', ['start_last_follow_time', 'end_last_follow_time'])
        handleDate(params, 'nextFollowEndDate', ['start_next_follow_end_time', 'end_next_follow_end_time'])
        handleDate(params, 'visitStoreDate', ['start_visit_store_date', 'end_visit_store_date'])
        handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])

        if (params.channel_id) {
            params.channel_id = params.channel_id.join(',')
        }

        if (params.intention_store_id) {
            params.intention_store_id = params.intention_store_id.join(',')
        }

        if (params.first_belong_store_id) {
            params.first_belong_store_id = params.first_belong_store_id.join(',')
        }

        if (params.belong_store_id) {
            params.belong_store_id = params.belong_store_id.join(',')
        }

        if (params.before_gone_init_store_id) {
            params.before_gone_init_store_id = params.before_gone_init_store_id.join(',')
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        baseAxiosComplete('/markting_center/customer/intention/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    let belongKFOptions = belongKFData.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))
    let belongHospitalOptions = belongHospital.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))
    let inChargeOptions = inChargeData.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))
    let channelAnchorOptions = channelAnchorData.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))
    let followSalesOptions = followSalesData.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))
    let followLevelOptions = followLevelData.map((el: any) => (<Option value={el.id} key={el.id}>{el.follow_level}</Option>))

    return (<div className="common-page">
        {/* 营销中心 -> 客资管理 -> 我的总客资 */}
        <BreadCrumb position={['营销中心', '我的总客资']} />

        <div className="common-top-form">
            <Row gutter={16} style={{ marginBottom: 20, marginLeft: 20 }}>
                <Col span={6}>
                    <Statistic title="我的总客资" value={pagination.total} />
                </Col>
            </Row>

            <Space direction="horizontal" wrap>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["线索开始日期", "线索结束日期"]} value={fetchOtherParams.clueDate} onChange={(v: any) => { handleChange(v, 'clueDate') }} />

                {/* 客资信息 */}
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} value={fetchOtherParams.customer_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} value={fetchOtherParams.phone} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="其他联系方式" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'contact_way') }} value={fetchOtherParams.contact_way} />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="怀孕状态" value={fetchOtherParams.preg_status} onChange={(v: number) => { handleChange(v, 'preg_status') }}>
                    <Option value={1} key={1}>正在备孕</Option>
                    <Option value={2} key={2}>已经怀孕</Option>
                    <Option value={3} key={3}>已有宝宝</Option>
                    <Option value={4} key={4}>小月子</Option>
                    <Option value={0} key={0}>未知</Option>
                </Select>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 280 }} className="fl" placeholder={["预产期开始日期", "预产期结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 130 }} placeholder="是否有效客资" value={fetchOtherParams.is_effective_customer} onChange={(v: number) => { handleChange(v, 'is_effective_customer') }}>
                    <Option value={1} key={1}>有效</Option>
                    <Option value={2} key={2}>待激活</Option>
                    <Option value={3} key={3}>最终流失</Option>
                </Select>
                <Select
                    allowClear
                    showSearch
                    mode="multiple"
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder="客资状态（多选）"
                    value={fetchOtherParams.customer_status === undefined ? undefined : fetchOtherParams.customer_status.split(',')}
                    onChange={(v: any[]) => {
                        handleChange(v.length > 0 ? v.join(',') : undefined, 'customer_status')
                    }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    <Option value={'3'} key={3}>待跟进</Option>
                    <Option value={'4'} key={4}>待预约进店</Option>
                    <Option value={'5'} key={5}>已预约待进店</Option>
                    <Option value={'6'} key={6}>已进店</Option>
                    <Option value={'7'} key={7}>已签单</Option>
                    <Option value={'8'} key={8}>待激活</Option>
                    <Option value={'9'} key={9}>已流失</Option>
                </Select>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="所在城市" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'location_city_name') }} value={fetchOtherParams.location_city_name} />
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="意向门店"
                        value={fetchOtherParams.intention_store_id}
                        onChange={(v: string[]) => {
                            handleChange(v, 'intention_store_id')
                        }}
                    />
                </div>

                {/* 渠道信息 */}
                <TreeSelect
                    showSearch
                    multiple={true}
                    allowClear
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 230 }}
                    value={fetchOtherParams.channel_id}
                    virtual={false}
                    treeData={recursionChildren(fromItemData)}
                    placeholder="来源渠道（可多选）"
                    onChange={(v: any) => {
                        handleChange(v, 'channel_id')
                    }}
                    filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)}
                />
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="来源渠道负责人"
                    value={fetchOtherParams.channel_manager_id}
                    onChange={(v: string) => { handleChange(v, 'channel_manager_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {inChargeOptions}
                </Select>
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="来源渠道主播"
                    value={fetchOtherParams.channel_anchor_id}
                    onChange={(v: string) => { handleChange(v, 'channel_anchor_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {channelAnchorOptions}
                </Select>

                {/* 录入信息 */}
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="录入人名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'create_user_name') }} value={fetchOtherParams.create_user_name} />
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="录入人角色"
                    value={fetchOtherParams.create_user_position_number}
                    onChange={(v: number) => { handleChange(v, 'create_user_position_number') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    <Option value={1} key={1}>客服</Option>
                    <Option value={11} key={11}>线上推广专员</Option>
                    <Option value={13} key={13}>线上推广组长</Option>
                    <Option value={14} key={14}>新媒体专员</Option>
                    <Option value={15} key={15}>新媒体组长</Option>
                    <Option value={2} key={2}>总部医务专员</Option>
                    <Option value={12} key={12}>门店医务专员</Option>
                    <Option value={7} key={7}>总部店销售</Option>
                    <Option value={3} key={3}>门店销售</Option>
                </Select>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["录入开始日期", "录入结束日期"]} value={fetchOtherParams.recordDate} onChange={(v: any) => { handleChange(v, 'recordDate') }} />

                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="所属客服"
                    value={fetchOtherParams.belong_cs_id}
                    onChange={(v: string) => { handleChange(v, 'belong_cs_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {belongKFOptions}
                </Select>
                <Select
                    allowClear
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="所属医务"
                    value={fetchOtherParams.belong_hospital_id}
                    onChange={(v: number) => { handleChange(v, 'belong_hospital_id') }}
                >
                    {belongHospitalOptions}
                </Select>

                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="首次分配门店"
                        value={fetchOtherParams.first_belong_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'first_belong_store_id') }}
                    />
                </div>
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 130 }}
                    placeholder="首次分配销售"
                    value={fetchOtherParams.first_belong_sales_id}
                    onChange={(v: string) => { handleChange(v, 'first_belong_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>

                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="当前所属门店"
                        value={fetchOtherParams.belong_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'belong_store_id') }}
                    />
                </div>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="所属销售"
                    value={fetchOtherParams.init_sales_id}
                    onChange={(v: string) => { handleChange(v, 'init_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="跟进销售"
                    value={fetchOtherParams.follow_sales_id}
                    onChange={(v: string) => { handleChange(v, 'follow_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>

                <Select allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 130 }} placeholder="是否曾经流失" value={fetchOtherParams.has_gone} onChange={(v: number) => { handleChange(v, 'has_gone') }}>
                    <Option value={0} key={0}>否</Option>
                    <Option value={1} key={1}>是</Option>
                </Select>
                <Select
                    showSearch
                    mode="multiple"
                    virtual={false}
                    allowClear
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder="最新流失分类(可多选)"
                    value={fetchOtherParams.no_effective_reason_id === undefined ? undefined : fetchOtherParams.no_effective_reason_id.split(',')}
                    onChange={(v: any) => {
                        handleChange(v.length > 0 ? v.join(',') : undefined, 'no_effective_reason_id')
                    }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {loseTypeData.map((el: loseType) => <Option value={el.id} key={el.id}>{el.reason_desc}</Option>)}
                </Select>

                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        showSearch
                        multiple
                        placeholder="流失前初始门店"
                        value={fetchOtherParams.before_gone_init_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'before_gone_init_store_id') }}
                    />
                </div>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="流失前初始销售"
                    value={fetchOtherParams.before_gone_init_sales_id}
                    onChange={(v: string) => { handleChange(v, 'before_gone_init_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="流失前跟进销售"
                    value={fetchOtherParams.before_gone_follow_sales_id}
                    onChange={(v: string) => { handleChange(v, 'before_gone_follow_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>

                <Select
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="跟进等级" value={fetchOtherParams.follow_level_id} onChange={(v: string) => { handleChange(v, 'follow_level_id') }}>
                    {followLevelOptions}
                </Select>

                <div className="clear fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <Input className="fl" style={{ width: '120px' }} placeholder="最小跟进次数" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'min_follow_times') }} value={fetchOtherParams.min_follow_times} />
                    <div className="fl" style={{ margin: '0 5px' }}>-</div>
                    <Input className="fl" style={{ width: '120px' }} placeholder="最大跟进次数" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'max_follow_times') }} value={fetchOtherParams.max_follow_times} />
                </div>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 300 }} className="fl" placeholder={["最新跟进开始日期", "最新跟进结束日期"]} value={fetchOtherParams.lastFollowDate} onChange={(v: any) => { handleChange(v, 'lastFollowDate') }} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 300 }} className="fl" placeholder={["下次跟进开始日期", "下次跟进结束日期"]} value={fetchOtherParams.nextFollowEndDate} onChange={(v: any) => { handleChange(v, 'nextFollowEndDate') }} />

                <div className="clear fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <Input className="fl" style={{ width: '120px' }} placeholder="最小进店次数" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'min_total_visit_times') }} value={fetchOtherParams.min_total_visit_times} />
                    <div className="fl" style={{ margin: '0 5px' }}>-</div>
                    <Input className="fl" style={{ width: '120px' }} placeholder="最大进店次数" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'max_total_visit_times') }} value={fetchOtherParams.max_total_visit_times} />
                </div>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 300 }} className="fl" placeholder={["最新进店开始日期", "最新进店结束日期"]} value={fetchOtherParams.visitStoreDate} onChange={(v: any) => { handleChange(v, 'visitStoreDate') }} />
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        showSearch
                        placeholder="最新进店名称"
                        value={fetchOtherParams.visit_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'visit_store_id') }}
                    />
                </div>

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 300 }} className="fl" placeholder={["签单开始日期", "签单结束日期"]} value={fetchOtherParams.dealDate} onChange={(v: any) => { handleChange(v, 'dealDate') }} />
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="签单门店"
                        value={fetchOtherParams.deal_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'deal_store_id') }}
                    />
                </div>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="签单销售"
                    value={fetchOtherParams.deal_sales_id}
                    onChange={(v: string) => { handleChange(v, 'deal_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="手机号" dataIndex="phone" key="phone" />
                <Column title="其他联系方式" dataIndex="contact_way" key="contact_way" />

                <Column title="怀孕状态" dataIndex="preg_status" key="preg_status" render={(v: number) => {
                    switch (v) {
                        case 1:
                            return '正在备孕'
                        case 2:
                            return '已经怀孕'
                        case 3:
                            return '已有宝宝'
                        case 4:
                            return '小月子'
                        case 0:
                            return '未知'
                        default:
                            return ''
                    }
                }} />
                <Column title="预产期" dataIndex="expect_born_day" key="expect_born_day" />

                <Column title="是否有效客资" dataIndex="is_effective_customer" key="is_effective_customer" render={(v: number) => {
                    switch (v) {
                        case 1:
                            return '有效'
                        case 2:
                            return '待激活'
                        case 3:
                            return '最终流失'
                        default:
                            return ''
                    }
                }} />
                <Column title="客资状态" dataIndex="status" key="status" render={(v: number) => {
                    switch (v) {
                        case 3:
                            return '待跟进'
                        case 4:
                            return '待预约进店'
                        case 5:
                            return '已预约待进店'
                        case 6:
                            return '已进店'
                        case 7:
                            return '已签单'
                        case 8:
                            return '待激活'
                        case 9:
                            return '已流失'
                        default:
                            return ''
                    }
                }} />

                <Column title="来源渠道" dataIndex="channel_name" key="channel_name" />
                <Column title="来源渠道主播" dataIndex="channel_anchor_name" key="channel_anchor_name" />
                <Column title="所在城市" dataIndex="location_city_name" key="location_city_name" />
                <Column title="意向门店" dataIndex="intention_store_name" key="intention_store_name" />

                <Column title="报备内容" dataIndex="remark" key="remark" width={650} render={
                    info => {
                        let br = <br></br>;
                        let result = null;
                        let content_list = info.split('\n')

                        for (let j = 0; j < content_list.length; j++) {
                            if (j === 0) {
                                result = content_list[j];
                            } else {
                                result = <span>{result}{br}{content_list[j]}</span>;
                            }
                        }

                        return <div>{result}</div>;
                    }}
                />

                <Column title="录入人/角色" render={(v: any) => {
                    return <p>{v.create_user_name}/{v.create_user_position}</p>
                }} />
                <Column title="录入时间" dataIndex="create_time" key="create_time" />

                <Column title="所属客服" dataIndex="belong_cs_name" key="belong_cs_name" />
                <Column title="所属医务" width="120px" dataIndex="belong_hospital_name" key="belong_hospital_name" />

                <Column title="首次分配门店" dataIndex="first_belong_store_name" key="first_belong_store_name" />
                <Column title="首次分配销售" dataIndex="first_belong_sales_name" key="first_belong_sales_name" />
                <Column title="当前所属门店" width="120px" dataIndex="belong_store_name" key="belong_store_name" />
                <Column title="所属销售" width="120px" dataIndex="init_sales_name" key="init_sales_name" />
                <Column title="所属销售接收时间" dataIndex="init_sales_accept_time" key="init_sales_accept_time" />
                <Column title="跟进销售" dataIndex="follow_sales_name" key="follow_sales_name" />
                <Column title="跟进销售接收时间" dataIndex="follow_sales_accept_time" key="follow_sales_accept_time" />

                <Column title="是否曾经流失" dataIndex="has_gone" key="has_gone" />
                <Column title="曾经流失次数" render={(v: any) => {
                    return (<Button onClick={() => {
                        setLossVisible(true)

                        baseAxiosNoInfo('/markting_center/customer/intention/gone_records_list', { params: { id: v.id } }).then((res: any) => {
                            res ? setLossData(res) : setLossData([])
                        })
                    }} type="dashed" size="small">{v.has_gone_times}</Button>)
                }} />
                <Column title="最新流失分类" dataIndex="no_effective_reason" key="no_effective_reason" />

                <Column title="流失前初始门店" dataIndex="before_gone_init_store_name" key="before_gone_init_store_name" />
                <Column title="流失前初始销售" dataIndex="before_gone_init_sales_name" key="before_gone_init_sales_name" />
                <Column title="流失前跟进销售" dataIndex="before_gone_follow_sales_name" key="before_gone_follow_sales_name" />

                <Column title="最新跟进等级" dataIndex="last_follow_level" key="last_follow_level" />
                <Column title="跟进次数" render={(v: any) => {
                    return (<Button onClick={() => {
                        setFollowRecordVisible(true)
                        baseAxiosNoInfo('/markting_center/customer/intention/follow_records_list', { params: { id: v.id } }).then((res: any) => {
                            res ? setFollowRecordData(res) : setFollowRecordData([])
                        })
                    }} type="dashed" size="small">{v.follow_times}</Button>)
                }} />

                <Column title="最新跟进时间" dataIndex="last_follow_time" key="last_follow_time" />
                <Column title="最新跟进原因" dataIndex="last_follow_reason_desc" key="last_follow_reason_desc" />
                <Column title="下次跟进截止日期" dataIndex="next_follow_end_time" key="next_follow_end_time" />

                <Column title="进店次数" render={(v: any) => {
                    return (<Button onClick={() => {
                        setInStoreRecordVisible(true)
                        baseAxiosNoInfo('/markting_center/customer/intention/visit_records_list', { params: { id: v.id } }).then((res: any) => {
                            res ? setInStoreRecordData(res) : setInStoreRecordData([])
                        })
                    }} type="dashed" size="small">{v.total_visit_times}</Button>)
                }} />
                <Column title="最新进店日期" dataIndex="visite_store_date" key="visite_store_date" />
                <Column title="最新进店名称" dataIndex="visite_store_name" key="visite_store_name" />
                <Column title="最新进店原因" dataIndex="visite_store_reason_desc" key="visite_store_reason_desc" />

                <Column title="签单录入时间" dataIndex="deal_create_time" key="deal_create_time" />
                <Column title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column title="签单销售" dataIndex="deal_sales_name" key="deal_sales_name" />
                <Column title="签单套餐" dataIndex="deal_item_name" key="deal_item_name" />

                <Column title="套餐天数/赠送天数" render={(v: any) => {
                    if (v.item_days || v.gift_days) {
                        return <span>{v.item_days}/{v.gift_days}</span>
                    } else {
                        return null
                    }
                }} />
                <Column title="合同凭证" render={(row: any) => {
                    if (row.status === 7) {
                        return <Button onClick={() => {
                            setUrls(row.deal_prov_pic_list)
                            setSiperVisible(true)
                        }} size="small" >查看</Button>

                    } else {
                        return null
                    }
                }} />

                <Column title="合同金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="已收总金额" render={(v: any) => {
                    return (<Button onClick={() => {
                        setInMoneyRecordVisible(true)
                        baseAxiosNoInfo('/markting_center/customer/intention/pay_records_list', { params: { id: v.id } }).then((res: any) => {
                            res ? setInMoneyRecordData(res) : setInMoneyRecordData({ "total_agreement_amount": 0, "total_review_amount": 0, "total_pay_amount": 0, pay_records_list: [] })
                        })
                    }} type="dashed" size="small">{v.total_pay_amount}</Button>)
                }} />
            </Table>
        </div>

        {/* 弹窗：流失记录 */}
        <Modal zIndex={10} width={1000} bodyStyle={{ minHeight: 600 }} title="流失记录" visible={lossVisible} onCancel={() => { setLossVisible(false) }} footer={false}>
            <Table scroll={{ x: 'max-content' }} pagination={false} dataSource={lossData}>
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="跟进方式" dataIndex="follow_way" key="follow_way" render={(v: number) => {
                    if (v === 1) {
                        return '电话 '
                    } else if (v === 2) {
                        return '微信'
                    } else if (v === 3) {
                        return 'qq'
                    } else if (v === 4) {
                        return '邮箱'
                    } else {
                        return ''
                    }
                }} />
                <Column title="流失日期" dataIndex="follow_time" key="follow_time" />
                <Column title="流失原因" dataIndex="no_effective_reason" key="no_effective_reason" />
                <Column title="流失原因备注" dataIndex="no_effective_reason_remark" key="no_effective_reason_remark" />
                <Column title="判定流失人" dataIndex="follow_man_name" key="follow_man_name" />
            </Table>
        </Modal>

        {/* 弹窗：跟进记录 */}
        <Modal zIndex={10} width={1000} bodyStyle={{ minHeight: 600 }} title="跟进记录" visible={followRecordVisible} onCancel={() => { setFollowRecordVisible(false) }} footer={false}>
            <Table scroll={{ x: 'max-content' }} pagination={false} dataSource={followRecordData}>
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="客资状态" dataIndex="status" key="status" render={(v: number) => {
                    switch (v) {
                        case 3:
                            return '待跟进'
                        case 4:
                            return '待预约进店'
                        case 5:
                            return '已预约待进店'
                        case 6:
                            return '已进店'
                        case 7:
                            return '已签单'
                        case 8:
                            return '待激活'
                        case 9:
                            return '已流失'
                        default:
                            return ''
                    }
                }} />
                <Column width="200px" title="跟进方式" dataIndex="follow_way" key="follow_way" render={(v: number) => {
                    switch (v) {
                        case 1:
                            return '电话'
                        case 2:
                            return '微信'
                        case 3:
                            return 'qq'
                        case 4:
                            return '邮箱'
                        default:
                            return ''
                    }
                }} />
                <Column title="跟进等级" dataIndex="follow_level" key="follow_level" />
                <Column title="跟进内容" dataIndex="follow_content" key="follow_content" />
                <Column title="是否有效线索" dataIndex="is_effective_clue" key="is_effective_clue" render={(v: number) => v === 1 ? '无效' : '有效'} />
                <Column title="无效线索原因" dataIndex="no_effective_clue_reason" key="no_effective_clue_reason" />
                <Column title="是否有效客资" dataIndex="is_effective_customer" key="is_effective_customer" render={(v: number) => {
                    if (v === 0) {
                        return '未知'
                    } else if (v === 1) {
                        return '有效'
                    } else {
                        return '无效'
                    }
                }} />
                <Column title="无效客资原因" dataIndex="no_effective_customer_reason" key="no_effective_customer_reason" />
                <Column title="分配销售" dataIndex="distributed_sales_name" key="distributed_sales_name" />
                <Column title="是否邀约进店" dataIndex="is_invite_visit" key="is_invite_visit" render={(v: number) => {
                    if (v === 0) {
                        return '未知'
                    } else if (v === 1) {
                        return '已邀约'
                    } else {
                        return '未有进店计划'
                    }
                }} />
                <Column title="邀约进店日期" dataIndex="visit_date" key="visit_date" />
                <Column title="邀约进店门店" dataIndex="store_name" key="store_name" />
                <Column title="到店是否本人跟进" dataIndex="is_self_follow" key="is_self_follow" render={(v: number) => {
                    if (v === 0) {
                        return '未知'
                    } else if (v === 1) {
                        return '是'
                    } else {
                        return '否'
                    }
                }} />
                <Column title="到店跟进销售" dataIndex="deal_sales_name" key="deal_sales_name" />
                <Column title="下次跟进截止日期" dataIndex="next_follow_limit_date" key="next_follow_limit_date" />
                <Column title="备注" dataIndex="remark" key="remark" />
                <Column title="创建人" dataIndex="follow_man_name" key="follow_man_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
            </Table>
        </Modal>

        {/* 弹窗：进店记录 */}
        <Modal zIndex={10} width={1000} bodyStyle={{ minHeight: 600 }} title="进店记录" visible={inStoreRecordVisible} onCancel={() => { setInStoreRecordVisible(false) }} footer={false}>
            <Table scroll={{ x: 'max-content' }} pagination={false} dataSource={inStoreRecordData}>
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="客资状态" dataIndex="status" key="status" render={(v: number) => {
                    switch (v) {
                        case 3:
                            return '待跟进'
                        case 4:
                            return '待预约进店'
                        case 5:
                            return '已预约待进店'
                        case 6:
                            return '已进店'
                        case 7:
                            return '已签单'
                        case 8:
                            return '待激活'
                        case 9:
                            return '已流失'
                        default:
                            return ''
                    }
                }} />
                <Column title="进店日期" dataIndex="visit_date" key="visit_date" />
                <Column title="进店门店" dataIndex="store_name" key="store_name" />
                <Column title="进店沟通内容" dataIndex="content" key="content" />
                <Column title="跟进等级" dataIndex="follow_level" key="follow_level" />
                <Column title="分娩医院" dataIndex="childbirth_hospital" key="childbirth_hospital" />
                <Column title="胎次" dataIndex="preg_times" key="preg_times" />
                <Column title="意向套餐" dataIndex="item_name" key="item_name" />
                <Column title="是否试吃月子餐" dataIndex="sample_food" key="sample_food" />
                <Column title="是否签单" dataIndex="make_deal" key="make_deal" />
                <Column title="未成交原因" dataIndex="no_deal_reason" key="no_deal_reason" />
                <Column title="备注" dataIndex="remark" key="remark" />
                <Column title="创建人" dataIndex="current_follow_man_name" key="current_follow_man_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
            </Table>
        </Modal>

        {/* 弹窗：合同凭证 */}
        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />

        {/* 弹窗：已收金额记录 */}
        <Modal zIndex={10} width={1000} bodyStyle={{ minHeight: 600 }} title="已收金额记录" visible={inMoneyRecordVisible} onCancel={() => { setInMoneyRecordVisible(false) }} footer={false}>
            <p style={{ fontSize: '18px', color: '#faad14' }}>合同总金额：{inMoneyRecordData.total_agreement_amount}元</p>
            <p>已收总金额：{inMoneyRecordData.total_pay_amount}元，已审核金额：{inMoneyRecordData.total_review_amount}元</p>

            <Table scroll={{ x: 'max-content' }} pagination={false} dataSource={inMoneyRecordData.pay_records_list}>
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="收款日期" dataIndex="pay_date" key="pay_date" />
                <Column title="收款项目" dataIndex="pay_item" key="pay_item" />
                <Column title="收款单号" dataIndex="pay_code" key="pay_code" />
                <Column title="收款方式" dataIndex="pay_way" key="pay_way" render={(v: number) => {
                    if (v === 1) {
                        return '现金'
                    } else if (v === 2) {
                        return '支付宝'
                    } else if (v === 3) {
                        return '微信'
                    } else if (v === 4) {
                        return '银联卡'
                    } else {
                        return ''
                    }
                }} />
                <Column title="收款金额" dataIndex="pay_amount" key="pay_amount" />
                <Column width="120px" title="收款凭证" render={(row: any) => {
                    return <Button onClick={() => {
                        setUrls(row.pay_prov_pic_list)
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />
                <Column title="收款人" dataIndex="deal_sales_name" key="deal_sales_name" />

                <Column title="审核状态" dataIndex="review_status" key="review_status" render={(v: number) => {
                    if (v === 0) {
                        return '待审核'
                    } else if (v === 1) {
                        return '审核通过'
                    } else if (v === 2) {
                        return '审核不通过'
                    } else {
                        return ''
                    }
                }} />
                <Column title="审核拒绝原因" dataIndex="review_refuse_reason" key="review_refuse_reason" />
                <Column title="审核人" dataIndex="review_user_name" key="review_user_name" />
                <Column title="审核时间" dataIndex="review_time" key="review_time" />
            </Table>
        </Modal>
    </div>)
}